import { useLiveOrders } from '../../lib/useLiveOrders';
import { STATUS_LABEL } from '../../lib/format';
import { TopBar } from '../TopBar';

export function Display() {
  const { orders } = useLiveOrders('display');
  const visible = orders.filter((o) => o.status !== 'PENDING_PAYMENT');

  return (
    <div className="kiosk wide">
      <TopBar />
      <div className="staff-header">
        <div className="staff-title">📺 Commandes</div>
        <div className="staff-subtitle">Écran de salle</div>
      </div>
      {visible.length === 0 ? (
        <div className="no-data">En attente de commandes…</div>
      ) : (
        <div className="d-grid">
          {visible.map((o) => (
            <div key={o.id} className={`d-card ${o.status}`}>
              <div style={{ fontSize: '.6rem', fontWeight: 900, textTransform: 'uppercase', opacity: 0.7 }}>
                {STATUS_LABEL[o.status]}
              </div>
              <div className="d-id">#{o.number}</div>
              <div className="d-client">{o.clientName}</div>
              <div style={{ fontSize: '.65rem', color: 'var(--muted)' }}>
                {o.type === 'DINE_IN' ? '🪑 Sur place' : '🛍️ À emporter'}
              </div>
              {o.status === 'READY' && <div className="d-ready">🔔 PRÊT — VENEZ !</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
